module.exports = __webpack_public_path__ + "img/ИФ-1(А)-024-m.c80fb680.png";